import { render, staticRenderFns } from "./ViewCheckoffAttachments.vue?vue&type=template&id=e16b1234&scoped=true&"
import script from "./ViewCheckoffAttachments.vue?vue&type=script&lang=js&"
export * from "./ViewCheckoffAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16b1234",
  null
  
)

export default component.exports